<template>
  <TransparentCard container-tag="section" container-class="prof_usr_top">
    <div class="banner">
      <a
        href="#"
        @mouseenter="isEditProfileLinkHovered = true"
        @mouseleave="isEditProfileLinkHovered = false"
        @click.prevent="redirectTo('ProfileEdit')"
      >
        <BaseImage :src="editProfileImage" image-class="edit_prof_btn" alt="Edit Profile" />
      </a>

      <AvatarImage :src="authStore.userAvatar" image-class="avatar" alt="Avatar" />
    </div>

    <div class="avatar_info">
      <h3 class="avatar_name">{{ authStore.userUsername }}</h3>

      <SummaryStatsItem
        :value="levelNumberText"
        :description="authStore.userLevelName"
        :icon-src="authStore.userLevelIcon"
        icon-alt="Level"
      />

      <TransparentCard container-class="flex-row">
        <div class="right level_up">
          <template v-if="authStore.hasUserCompletedAllLevels">
            <p>
              {{ $_translations.value.page_profile_overview_section_summary_completed_all_levels }}
            </p>
          </template>

          <template v-else>
            <p>
              {{ authStore.userNextLevelGapTotal }}
              {{ $_translations.value.page_profile_overview_section_summary_games_to_level_up }}
            </p>

            <BaseProgressBar :value="authStore.userNextLevelProgressPercentage" />
          </template>
        </div>
      </TransparentCard>

      <SummaryStatsItem
        :value="authStore.user.gamesPlayed"
        description="page_profile_overview_section_summary_item_games"
        :icon-src="gamesImage"
        icon-alt="Games"
      />

      <SummaryStatsItem
        :value="authStore.user.totalPointsEarned"
        description="page_profile_overview_section_summary_item_points"
        :icon-src="pointsImage"
        icon-alt="Points"
      />
    </div>
  </TransparentCard>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import BaseProgressBar from '@/components/bar/BaseProgressBar.vue';
import SummaryStatsItem from '@/views/profileOverview/components/item/SummaryStatsItem.vue';
import useAuthStore from '@/store/modules/auth.js';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';
import { gamesImage, pointsImage } from '@/constants/image.js';

const { proxy } = getCurrentInstance();

const authStore = useAuthStore();

const { redirectTo } = usePageNavigationHook();

const isEditProfileLinkHovered = ref(false);

const editProfileImage = computed(() => isEditProfileLinkHovered.value ? '/static/images/edit_btn_over.svg' : '/static/images/edit_btn.svg');

const levelNumberText = computed(() => [proxy.$_translate('common_level_short'), authStore.user.level].join(' '));
</script>
